/** The different layouts the editor should support */
export const layouts = {
  spinner: 'spinner',
  default: 'default',
  wide: 'wide',
  small: 'small',
};

export const displayLayouts = [layouts.small, layouts.default, layouts.wide];

/** Elements that can be a part of the editor */
export const identifiers = {
  description: 'description',
  summary: 'summary',
  flow: 'flow',
  api: 'api',
  implementation: 'implementation',
  solution: 'solution',
  discussion: 'discussion',
  apiSettings: 'apiSettings',
  graphicsSettings: 'graphicsSettings',
  settings: 'settings',
  preview: 'preview',
  console: 'console',
  score: 'score',
  errorTab: 'errorTab',
  canvas: 'canvas', // Has no tab label since it is managed separately
  result: 'result', // used for result column with canvas and console
  course: 'course', // Used for exercises when taken as part of a course
  enableSkeletonEditing: 'enableSkeletonEditing',
};

export const buttonIds = {
  runButton: 'freecodeRunCode',
  selectLanguage: 'freecodeSelectLanguage',
  submitButton: 'freecodeSubmitCode',
  helpButton: 'freecodeHelpButton',
  layoutDropdown: 'freecodeLayoutDropdown',
  publishDropdown: 'freecodePublishDropdown',
  interactDropdown: 'freecodePlayerInteractDropdown',
  reportButton: 'freecodeReportButton',
  saveButton: 'freecodeSaveButton',
  exportButton: 'freecodeExportButton',
  importButton: 'freecodeImportButton',
  wikiLink: 'freecodeWikiLink',
  toggleDarkMode: 'freecodeToggleDarkMode',
  copyButton: 'copyButton',
  liveCodingStatusButton: 'freecodeLiveCodingStatusButton',
  liveCodingSelectedLanguage: 'freecodeLiveCodingSelectedLanguage',
};

/** Icons and labels to use for different tabs */
export const tabLabels = {
  [identifiers.description]: {
    icon: 'fa fa-info-circle',
    label: 'Description',
    tabId: 'freecodeDescriptionTab',
  },
  [identifiers.summary]: {
    icon: 'fa fa-info-circle',
    label: 'Summary',
    tabId: 'freecodeSummaryTab',
  },
  [identifiers.flow]: {
    icon: 'fa fa-info-circle',
    label: 'Flow',
    tabId: 'freecodeFlowTab',
  },
  [identifiers.api]: {
    icon: 'fa fa-book',
    label: 'API',
    tabId: 'freecodeAPITab',
  },
  [identifiers.implementation]: {
    icon: 'fa fa-code',
    label: 'Implementation',
  },
  [identifiers.solution]: {
    icon: 'fa fa-code',
    label: 'Solution',
  },
  [identifiers.discussion]: {
    icon: 'fa-regular fa-comments',
    label: 'Discussion',
  },
  [identifiers.apiSettings]: {
    icon: 'fa fa-book',
    label: 'API',
  },
  [identifiers.graphicsSettings]: {
    icon: 'fa-regular fa-image',
    label: 'Graphics',
  },
  [identifiers.settings]: {
    icon: 'fa fa-cog',
    label: 'Settings',
  },
  [identifiers.preview]: {
    icon: 'fa-solid fa-magnifying-glass',
    label: 'Preview',
  },
  [identifiers.console]: {
    icon: 'fa fa-terminal',
    label: 'Console',
    tabId: 'freecodeConsoleTab',
  },
  [identifiers.score]: {
    icon: 'fa fa-star',
    label: 'Score',
    tabId: 'freecodeScoreTab',
  },
  [identifiers.result]: {
    icon: 'fa fa-terminal',
    label: 'Result',
  },
  [identifiers.course]: {
    icon: 'fa fa-bars fa-lg',
    label: 'Course',
  },
  [identifiers.enableSkeletonEditing]: {
    icon: 'fa fa-pen',
    label: 'Custom Skeletons',
  },
  [identifiers.errorTab]: {
    icon: 'fa fa-exclamation-circle',
    label: 'Error',
    tabId: 'errorTab',
  },
};

/** Names/identifiers for the different kinds of freecode editors */
export const editorTypes = {
  freecode: 'freecodeTest',
  freecodeTrial: 'freecodeTestTrial',
  freecodeInspect: 'freecodeTestInspect',
  exercise: 'exerciseEditor',
  contest: 'contestEditor',
  creator: 'freecodeCreator',
  creatorInspect: 'freecodeCreatorInspect',
  liveCoding: 'freecodeLiveCoding',
};
